import { useState } from "react";
import { booker } from "@/content";

const plans = booker.pricing.plans;

export default function Pricing() {
  const [yearly, setYearly] = useState(false);

  return (
    <section id="pricing" className="py-24 bg-white dark:bg-[#0C0C0E] relative overflow-hidden">
      <div className="absolute top-0 left-1/4 w-[500px] h-[500px] rounded-full bg-yellow-200/25 dark:bg-yellow-500/10 blur-[120px] pointer-events-none" />
      <div className="absolute bottom-0 right-1/4 w-[400px] h-[400px] rounded-full bg-violet-200/25 dark:bg-violet-500/10 blur-[100px] pointer-events-none" />
      <div className="absolute top-1/2 right-0 w-[300px] h-[300px] rounded-full bg-red-200/20 dark:bg-red-500/10 blur-[100px] pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full bg-gray-100 dark:bg-slate-800/60 text-gray-600 dark:text-slate-400 text-xs font-semibold tracking-widest uppercase mb-4">{booker.pricing.badge}</span>
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 dark:text-white mb-4">{booker.pricing.title}</h2>
          <p className="text-gray-600 dark:text-slate-400 text-lg mb-8">{booker.pricing.subtitle}</p>

          {/* Toggle */}
          <div className="inline-flex items-center gap-3 bg-gray-100 dark:bg-slate-800/60 rounded-full px-1 py-1">
            <button
              onClick={() => setYearly(false)}
              className={`px-5 py-2 rounded-full text-sm font-semibold transition-all cursor-pointer whitespace-nowrap ${
                !yearly ? "bg-white dark:bg-slate-700 text-gray-900 dark:text-white shadow-sm" : "text-gray-600 dark:text-slate-400"
              }`}
            >{booker.pricing.toggle.monthly}</button>
            <button
              onClick={() => setYearly(true)}
              className={`px-5 py-2 rounded-full text-sm font-semibold transition-all cursor-pointer whitespace-nowrap ${
                yearly ? "bg-white dark:bg-slate-700 text-gray-900 dark:text-white shadow-sm" : "text-gray-600 dark:text-slate-400"
              }`}
            >{booker.pricing.toggle.yearly}<span className="ml-2 text-xs text-green-700 dark:text-green-400 font-bold">{booker.pricing.toggle.discount}</span>
            </button>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 items-center">
          {plans.map((plan) => (
            <div
              key={plan.name}
              className={`relative rounded-3xl p-8 transition-all duration-300 ${
                plan.highlight
                  ? "bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white scale-105 shadow-2xl dark:ring-1 dark:ring-white/[0.10]"
                  : "bg-white dark:bg-white/[0.04] border border-gray-100 dark:border-white/[0.08] text-gray-900 dark:text-white hover:shadow-lg"
              }`}
            >
              {plan.highlight && (
                <>
                  <div className="absolute inset-0 rounded-3xl overflow-hidden pointer-events-none">
                    <div className="absolute top-[-30%] left-[-20%] w-[300px] h-[300px] rounded-full bg-yellow-400/20 blur-[80px]" />
                    <div className="absolute bottom-[-20%] right-[-10%] w-[250px] h-[250px] rounded-full bg-red-500/20 blur-[70px]" />
                    <div className="absolute top-[30%] right-[-10%] w-[200px] h-[200px] rounded-full bg-pink-500/15 blur-[60px]" />
                  </div>
                  <div className="absolute -top-4 left-1/2 -translate-x-1/2 px-4 py-1.5 rounded-full bg-gradient-to-r from-yellow-400 to-red-400 text-white text-xs font-bold whitespace-nowrap shadow-lg">{booker.pricing.popularLabel}</div>
                </>
              )}

              <div className="relative z-10">
                <div className={`text-sm font-semibold mb-1 ${plan.highlight ? "text-white/70" : "text-gray-600 dark:text-slate-400"}`}>
                  {plan.desc}
                </div>
                <div className={`text-xl font-bold mb-2 ${plan.highlight ? "text-white" : "text-gray-900 dark:text-white"}`}>
                  {plan.name}
                </div>
                <div className="flex items-end gap-1 mb-6">
                  <span className={`text-4xl font-extrabold ${plan.highlight ? "text-white" : "text-gray-900 dark:text-white"}`}>
                    {yearly ? plan.price.yearly : plan.price.monthly} ₽
                  </span>
                  <span className={`text-sm mb-1 ${plan.highlight ? "text-white/70" : "text-gray-600 dark:text-slate-400"}`}>{booker.pricing.period}</span>
                </div>

                <ul className="space-y-3 mb-8">
                  {plan.features.map((f) => (
                    <li key={f} className="flex items-center gap-2.5 text-sm">
                      <div className={`w-5 h-5 flex items-center justify-center rounded-full flex-shrink-0 ${
                        plan.highlight
                          ? "bg-gradient-to-br from-yellow-400 to-red-400"
                          : "bg-gradient-to-br from-yellow-100 to-red-100 dark:from-yellow-400/20 dark:to-red-400/20"
                      }`}>
                        <i className={`ri-check-line text-xs ${plan.highlight ? "text-white" : "text-yellow-600 dark:text-yellow-400"}`}></i>
                      </div>
                      <span className={plan.highlight ? "text-white/80" : "text-gray-600 dark:text-slate-400"}>{f}</span>
                    </li>
                  ))}
                </ul>

                <a
                  href="#contact"
                  className={`block text-center py-3.5 rounded-2xl font-semibold text-sm transition-all cursor-pointer whitespace-nowrap ${
                    plan.highlight
                      ? "bg-gradient-to-r from-yellow-400 via-red-400 to-pink-400 text-white hover:opacity-90 shadow-lg"
                      : plan.name === "Старт"
                      ? "bg-gradient-to-r from-yellow-400 via-orange-400 to-red-400 text-white hover:opacity-90 shadow-md"
                      : "bg-gradient-to-r from-green-400 via-cyan-400 to-violet-500 text-white hover:opacity-90 shadow-md"
                  }`}
                >
                  {plan.cta}
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
